import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";

// CSS
import "../../src/assets/Standing.css";
import { Link, NavLink } from "react-router-dom";
import {
  DropdownButton,
  Dropdown,
  Table,
  Row,
  Col,
  Card,
} from "react-bootstrap";
import { CFormSelect } from "@coreui/react";

// tables Icon
import Batminton from "../components/icons/Batminton";
import TableTennis from "../components/icons/TableTennisIcon";
import Bowling from "../components/icons/Bowling";
import RunIcon from "../components/icons/RunIcon";
import main_logo from "../assets/images/UPG_site_logo.png";
import gold_medal from "../assets/images/games/bronzer.svg";
import silver_medal from "../assets/images/games/silver.svg";
import bronze_medal from "../assets/images/games/golden.svg";

// Images
import table_icon from "../assets/logo.png";
import dummy_gallery_img from "../assets/images/avatars/user.jpg";
import dummy_gallery_img_winner from "../assets/images/avatars/user.jpg";

import dummy_gallery_img_girl from "../assets/images/avatars/4.jpg";
import dummy_gallery_img_girl_winner from "../assets/images/avatars/5.jpg";

import { Profile, FetchAllPoints, WinnerGender, PhotoAPI } from "../API/player";
import {
  GetTournamentList,
  GetCorporate,
  TeamTopPerformer,
  FilterDynamicText,
  getSetting,
} from "../API/admin";
import { GetTeams } from "../API/auth";
import { useSnackbar } from "notistack";
import Loader from "../views/admin/Common/Loader";
import Swal from "sweetalert2";

function Standing() {
  const [loginUser, setLoginUser] = useState(null);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [dynamicHeading, setDynamicHeading] = useState({});

  let [loaderStatus, setloaderStatus] = useState(true);
  const [SelectedTournament, setSelectedTournament] = useState(null);
  const [SelectedTeam, setSelectedTeam] = useState(null);
  const [SelectedGame, setSelectedGame] = useState("bowling");
  const [SelectedWinnerGame, setSelectedWinnerGame] = useState("badminton");

  const [CorporateListMale, setCorporateListMale] = useState([]);
  const [CorporateListFemale, setCorporateListFemale] = useState([]);

  const [TopPerformerMale, setTopPerformerMale] = useState(null);
  const [TopPerformerFemale, setTopPerformerFemale] = useState(null);

  const [TopPerformerFilterMale, setTopPerformerFilterMale] = useState([]);
  const [TopPerformerFilterFemale, setTopPerformerFilterFemale] = useState([]);

  const [tournamentList, setTournamentList] = useState([]);
  const [teams, setTeams] = useState([]);
  const [teamTopPerformerMale, setTeamTopPerformerMale] = useState(null);
  const [teamTopPerformerFemale, setTeamTopPerformerFemale] = useState(null);
  const [showTeamTopPerformerMale, setShowTeamTopPerformeMale] =
    useState(false);
  const [showTeamTopPerformerFemale, setShowTeamTopPerformeFemale] =
    useState(false);

  const [MaleWinners, setMaleWinner] = useState([]);
  const [FemaleWinners, setFemaleWinner] = useState([]);
  const [allMalePerformers, setallMalePerformers] = useState([]);
  const [allFemalePerformers, setallFemalePerformers] = useState([]);
  const [TournamentOff, setTouramentOff] = useState(false);

  useEffect(() => {
    let callAPI = async () => {
      let res = await getSetting();

      if (res.status) {
        res.data.map((entry, index) => {
          if (entry.value == "false" && entry.name === "tournament_register") {
            setTouramentOff(true);
          }
        });
      } else {
        // setIsOn(null);
        enqueueSnackbar("unable to fetch setting", {
          variant: "error",
          action: (key) => (
            <button
              className="toast_close_btn"
              onClick={() => {
                // Close the Snackbar
                closeSnackbar(key);
              }}
            >
              X
            </button>
          ),
        });
      }
    };
    callAPI();
  }, []);
  // for male
  const getTopPerformers = () => {
    console.log("function called");
    console.log(SelectedTeam != null);
    console.log(SelectedGame != null);
    console.log(TopPerformerMale != null);

    if (
      SelectedTeam != null &&
      SelectedGame != null &&
      TopPerformerMale != null &&
      TopPerformerFemale != null
    ) {
      return [
        {
          male: TopPerformerMale[SelectedGame]?.[SelectedTeam] || [],
          female: TopPerformerFemale[SelectedGame]?.[SelectedTeam] || [],
        },
      ];
    }
    return [];
  };

  // for female
  // const getTopPerformersFemale = () => {
  //   console.log('function called')
  //   console.log(SelectedTeam != null)
  //   console.log(SelectedGame != null)
  //   console.log(TopPerformerFemale != null)

  //   if (SelectedTeam != null && SelectedGame != null && TopPerformerFemale != null) {
  //     return TopPerformerFemale[SelectedGame]?.[SelectedTeam] || []
  //   }
  //   return []
  // }

  const handleTeamChange = (e) => {
    setSelectedTeam(e.target.value);
  };

  const handleGameChange = (e) => {
    setSelectedGame(e.target.value);
  };
  const IMAGE_URL = process.env.REACT_APP_IMAGE_MY_ENVIRONMENT_VARIABLE;

  // do the same for female
  useEffect(() => {
    let TeamTopPerfromerAPI = async () => {
      let res = await TeamTopPerformer(SelectedTournament);
      console.log(res);
      if (res.status) {
        if (res.tournamentClosed) {
          setTeamTopPerformerMale(null);
        } else {
          setTeamTopPerformerMale(res.data);
        }
      }
    };
    if (SelectedTournament != null) {
      TeamTopPerfromerAPI();
    }
  }, [SelectedTournament]);
  useEffect(() => {
    let callAPI = async () => {
      let res = await Profile();
      console.log(res);
      if (res.statusCode == 403) {
        setLoginUser(null);
        setloaderStatus(false);
      } else {
        setLoginUser(res.data);
        setloaderStatus(false);
      }
    };

    let tournamentListApi = async () => {
      let res = await GetTournamentList();
      if (res.status) {
        setloaderStatus(false);
        setTournamentList(res.data);
        setSelectedTournament(res.data[0]._id);
      } else {
        setloaderStatus(false);
        enqueueSnackbar("Tournament not found", {
          variant: "error",
          action: (key) => (
            <button
              className="toast_close_btn"
              onClick={() => {
                // Close the Snackbar
                closeSnackbar(key);
              }}
            >
              X
            </button>
          ),
        });
      }
    };

    let getTeamsAPI = async () => {
      let res = await GetTeams();
      if (res.status) {
        setTeams(res.data);
        setSelectedTeam(res.data[0].domain);
      } else {
        setTeams([]);
        setSelectedTeam(null);
      }
    };
    getTeamsAPI();
    callAPI();
    tournamentListApi();
  }, []);

  useEffect(() => {
    let FetchAllPointsAPi = async () => {
      let FormData = {
        tournament_id: SelectedTournament,
      };
      setloaderStatus(true);

      let res = await FetchAllPoints(FormData);
      if (res.data.status) {
        setloaderStatus(false);
        // for male
        if (
          res.data.corporatestanding &&
          typeof res.data.corporatestanding === "object"
        ) {
          const CorporateListMaleDataMale = Object.keys(
            res.data.corporatestanding
          ).map((key) => ({
            name: key,
            badminton: res.data.corporatestanding[key].badminton,
            table_tennis: res.data.corporatestanding[key].table_tenis,
            bowling: res.data.corporatestanding[key].bowling,
            twokrun: res.data.corporatestanding[key].twokrun,
            total: res.data.corporatestanding[key].total,
            logo: res.data.corporatestanding[key].logo,
          }));
          setCorporateListMale(CorporateListMaleDataMale);
          setTopPerformerMale(res.data.male);
        } else {
          setCorporateListMale([]);
          setTopPerformerMale(null);
        }
        // for Female

        if (
          res.data.corporatestanding &&
          typeof res.data.corporatestanding === "object"
        ) {
          const CorporateListMaleDataFemale = Object.keys(
            res.data.corporatestanding
          ).map((key) => ({
            name: key,
            badminton: res.data.corporatestanding[key].badminton,
            table_tennis: res.data.corporatestanding[key].table_tenis,
            bowling: res.data.corporatestanding[key].bowling,
            twokrun: res.data.corporatestanding[key].twokrun,
            total: res.data.corporatestanding[key].total,
            logo: res.data.corporatestanding[key].logo,
          }));
          setCorporateListFemale(CorporateListMaleDataFemale);
          setTopPerformerFemale(res.data.female);
        } else {
          setCorporateListFemale([]);
          setTopPerformerFemale(null);
        }
      }
    };
    if (SelectedTournament != null) {
      FetchAllPointsAPi();
    }
  }, [SelectedTournament]);

  useEffect(() => {
    let WinnerGenderAPI = async () => {
      let FormData = {
        tournamentId: SelectedTournament,
        game_type: SelectedWinnerGame,
      };

      let res = await WinnerGender(FormData);
      if (res.data.status) {
        if (res.data.tournamentClosed) {
          setMaleWinner(null);
          setFemaleWinner(null);
        } else {
          setMaleWinner(res.data.data.male);
          setFemaleWinner(res.data.data.female);
        }
      }
      console.log(res.data.data.female);
    };
    if (SelectedTournament != null) {
      WinnerGenderAPI();
    }
  }, [SelectedTournament, SelectedWinnerGame]);

  //for male
  useEffect(() => {
    let data = getTopPerformers();
    console.log("data", data);
    if (data.length) {
      setTopPerformerFilterMale(data[0].male);
      setTopPerformerFilterFemale(data[0].female);
    }
  }, [TopPerformerMale, TopPerformerFemale, SelectedTeam, SelectedGame]);

  // for female
  // useEffect(() => {
  //   let data = getTopPerformersFemale()
  //   console.log('data', data)
  //   setTopPerformerFilterFemale(data)
  // }, [TopPerformerFemale, SelectedGame])

  const handleChange = (event) => {
    console.log(event.target);
    const selectedId = event.target.value;
    setSelectedTournament(selectedId);
    // setloaderStatus(true)
  };

  // useEffect(() => {
  //   function hasWinningPoints(data) {
  //     // Iterate over each team in the data
  //     for (let team in data) {
  //       // Iterate over each participant in the team
  //       for (let participant of data[team]) {
  //         // Check if any participant has totalWinningPoints greater than 0
  //         if (participant.totalWinningPoints > 0) {
  //           return true; // Return true if any participant has points
  //         }
  //       }
  //     }
  //     return false; // Return false if all participants have totalWinningPoints of 0
  //   }
  //   let res = hasWinningPoints(teamTopPerformerMale)
  //   setShowTeamTopPerformeMale(res)
  // }, [teamTopPerformerMale])
  useEffect(() => {
    let MalePerform = [];
    let FemalePerform = [];

    // Check if the teamTopPerformerMale and SelectedTeam are defined
    if (teamTopPerformerMale && SelectedTeam) {
      // Loop through the teamTopPerformerMale object
      Object.entries(teamTopPerformerMale).forEach(([teamName, performers]) => {
        // Check if the team matches the SelectedTeam
        if (teamName === SelectedTeam) {
          // Check if there are male performers for the selected team
          console.log("teamName", teamName);
          if (performers.male && performers.male.length > 0) {
            MalePerform.push(...performers.male); // Add only male performers of the selected team
          }
          // Check if there are female performers for the selected team
          if (performers.female && performers.female.length > 0) {
            FemalePerform.push(...performers.female); // Add only female performers of the selected team
          }
        }
      });
      // Set the state with the filtered performers for the selected team
      setallMalePerformers(MalePerform);
      setallFemalePerformers(FemalePerform);
    }
  }, [SelectedTeam, teamTopPerformerMale]); // Make sure teamTopPerformerMale and SelectedTeam are dependencies

  //  Photo/Video Request hit
  useEffect(() => {
    let callAPIDynamictext = async () => {
      let formData = {
        data: null,
      };
      let res = await FilterDynamicText(formData);
      if (res.data.status) {
        console.log(res.data.data);
        setDynamicHeading(res.data.data);
      }
    };
    callAPIDynamictext();
  }, []);

  let PhotoReq = async () => {
    console.log("Hello");
    Swal.fire({
      title: dynamicHeading.request_photo_video
        ? dynamicHeading.request_photo_video.title
        : "Request photo/video?",
      text: dynamicHeading.request_photo_video
        ? dynamicHeading.request_photo_video.value
        : "Request photo/video?",
      // icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Send Request",
      cancelButtonText: "Close",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let res = await PhotoAPI();
        if (res.data.status) {
          if (res.data.NoMatch) {
            enqueueSnackbar("You have not played any matches yet", {
              variant: "error",
              action: (key) => (
                <button
                  className="toast_close_btn"
                  onClick={() => {
                    // Close the Snackbar
                    closeSnackbar(key);
                  }}
                >
                  X
                </button>
              ),
            });
          } else {
            enqueueSnackbar("Request was sent successfully", {
              variant: "success",
              action: (key) => (
                <button
                  className="toast_close_btn"
                  onClick={() => {
                    // Close the Snackbar
                    closeSnackbar(key);
                  }}
                >
                  X
                </button>
              ),
            });
          }
        } else {
          enqueueSnackbar("Unable to send request at the moment", {
            variant: "error",
            action: (key) => (
              <button
                className="toast_close_btn"
                onClick={() => {
                  // Close the Snackbar
                  closeSnackbar(key);
                }}
              >
                X
              </button>
            ),
          });
        }
      }
    });
  };

  //    My profile navigation
  let Myprofilenavigate;
  if (loginUser) {
    switch (loginUser.role) {
      case "participant":
        Myprofilenavigate = "/participant/profile";
        break;
      case "admin":
        Myprofilenavigate = "/admin/profile";
        break;
      case "scorer":
        Myprofilenavigate = "/scorer/profile";
        break;
      default:
        Myprofilenavigate = "/";
        break;
    }
  } else {
    Myprofilenavigate = "/"; // Redirect to login if user is not logged in
  }
  const formatTitle = (text) => {
    return text
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  return (
    <>
      {loaderStatus ? <Loader /> : null}

      <div style={{ background: "#000" }}>
        <header>
          <nav className="navbar navbar-expand-lg navbar-light pt-3 pb-2 px-5 head_nav_landingpage">
            <a className="navbar-brand" href="/">
              <img src={main_logo} alt="Logo" />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
              style={{ background: "#B2022F" }}
            >
              {/* <span className="navbar-toggler-icon" /> */}
              <i
                class="bi bi-list"
                style={{ color: "#fff", fontSize: "25px" }}
              ></i>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav ms-auto nav-list">
                {loginUser != null ? (
                  <>
                    <li className="nav-item">
                      <a className="nav_page_btn" href="/">
                        Home
                      </a>
                    </li>
                    <li
                      className="nav-item"
                      style={{ display: loginUser != null ? "block" : "none" }}
                    >
                      <NavLink
                        className="nav_page_btn mobile_displa_dashboard"
                        to="/dashboard"
                        activeClassName="active"
                      >
                        Dashboard
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className="nav_page_btn"
                        to="/Results"
                        activeClassName="active"
                      >
                        Results
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className="nav_page_btn"
                        to="/photo-gallery"
                        activeClassName="active"
                      >
                        Gallery
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className="nav_page_btn"
                        to="/contact"
                        activeClassName="active"
                      >
                        Get in Touch
                      </NavLink>
                    </li>
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle"
                        href="#"
                        id="navbarDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img
                          src={
                            loginUser.profile_image !== undefined
                              ? IMAGE_URL + "user/" + loginUser.profile_image
                              : IMAGE_URL + "blank_user.png"
                          }
                          alt="Profile"
                          className="rounded-circle"
                          style={{
                            width: "60px",
                            height: "60px",
                            objectFit: "cover",
                          }}
                        />
                      </a>
                      <ul
                        className="dropdown-menu dropdown-menu-end new_header_dropdown"
                        aria-labelledby="navbarDropdown"
                      >
                        <li className="mobile_displa_popup_dashboard">
                          <NavLink className="dropdown-item" to="/dashboard">
                            Dashboard
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            className="dropdown-item"
                            to={Myprofilenavigate}
                          >
                            My Profile
                          </NavLink>
                        </li>
                        <li
                          style={{
                            display:
                              loginUser.role === "participant"
                                ? "block"
                                : "none",
                          }}
                          onClick={() => PhotoReq()}
                        >
                          <Link className="dropdown-item">
                            {" "}
                            Request Photo/Video
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/logout">
                            Logout
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </>
                ) : (
                  <>
                    <li className="nav-item">
                      <a className="nav_page_btn" href="/">
                        Home
                      </a>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className="nav_page_btn"
                        to="/Results"
                        activeClassName="active"
                      >
                        Results
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className="nav_page_btn"
                        to="/photo-gallery"
                        activeClassName="active"
                      >
                        Gallery
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className="nav_page_btn"
                        to="/contact"
                        activeClassName="active"
                      >
                        Get in Touch
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      {/* Changed to NavLink */}
                      <NavLink
                        className="signup_btn"
                        to="/register"
                        activeClassName="active"
                      >
                        Register Now
                      </NavLink>
                    </li>

                    <li className="nav-item">
                      <NavLink
                        className="login_btn"
                        to="/login"
                        activeClassName="active"
                      >
                        Login
                      </NavLink>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </nav>
        </header>
        <section className="headre_bg_div"></section>
        <div className="container-fluid pb-5" style={{ background: "#000" }}>
          <div className="container-lg main-container">
            <section className="team_standing_sectin">
              <Row className="text-white pt-4">
                <Col xs={12}>
                  <h3 className="all_new_pages_heading"> RESULTS </h3>
                </Col>
                <Col className="text-end" xs={12}>
                  <div className="d-flex justify-content-end align-items-center">
                    <div className="tournment_txt me-2">Tournament </div>
                    <CFormSelect
                      aria-label="Default select example"
                      //   onChange={handleRound}
                      onChange={handleChange}
                      className="bg-dark text-white table_selctbtn_standing"
                    >
                      {tournamentList && tournamentList.length ? (
                        <>
                          <option
                            value={tournamentList[0]._id.toString()}
                            selected
                          >
                            {tournamentList[0].name}
                          </option>
                          {tournamentList.slice(1).map((tournament, index) => (
                            <option
                              key={index + 1}
                              value={tournament._id.toString()}
                            >
                              {tournament.name}
                            </option>
                          ))}
                        </>
                      ) : (
                        ""
                      )}
                    </CFormSelect>
                    {/* static city button  */}
                    {/* <div> */}
                    <div className="top_perform_btn_heading_txt me-2">City</div>
                    <CFormSelect
                      aria-label="Default select example"
                      // onChange={handleTeamChange}
                      className="bg-dark text-white table_selctbtn_standing"
                    >
                      <option value="city-1">Melbourne </option>
                    </CFormSelect>
                    {/* </div> */}
                  </div>
                </Col>
              </Row>
              <Row className="py-3">
                <Col>
                  <Card className="border-radius25px overflow-auto border-0 corporate_standings">
                    <Card.Body className="p-0">
                      <Table
                        bordered
                        className="text-center mb-0 standings_table "
                      >
                        <thead className="border-0">
                          <tr className="border-0">
                            <th className="border-0 text-size table-th">
                              Teams
                            </th>
                            <th className="border-0 text-size table-th">
                              <Batminton />{" "}
                              <span className="text_hiderespons">
                                Badminton
                              </span>
                            </th>
                            <th className="border-0 text-size table-th">
                              <TableTennis />
                              <span className="text_hiderespons">
                                {" "}
                                Table Tennis
                              </span>
                            </th>
                            {/* <th className='border-0 text-size table-th'>
                              <Bowling />{' '}
                              <span className='text_hiderespons'>
                                {' '}
                                Bowling{' '}
                              </span>
                            </th>
                            <th className='border-0 text-size table-th'>
                              <RunIcon />{' '}
                              <span className='text_hiderespons'> 2k Run</span>
                            </th> */}
                            <th className="border-0 text-size table-th">
                              <span className="">Total</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {CorporateListMale && CorporateListMale.length > 0 ? (
                            CorporateListMale.sort(
                              (a, b) => b.total - a.total
                            ).map((entry, index) => (
                              <>
                                {console.log("entry", entry)}
                                <tr>
                                  <td
                                    className="standing_tbl_td d-flex align-items-center"
                                    style={{ minWidth: "155px" }}
                                  >
                                    <img
                                      src={
                                        entry.logo != undefined
                                          ? IMAGE_URL + "teams/" + entry.logo
                                          : table_icon
                                      }
                                      alt="img"
                                      className="standing_tble_icon"
                                    />
                                    <span className="standing_tbl_icon_txt">
                                      {entry.name}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "90px",
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    {entry.badminton}
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "90px",
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    {entry.table_tennis}
                                  </td>
                                  {/* <td style={{ minWidth: "90px", verticalAlign: "middle" }}>
                                    {entry.bowling}
                                  </td>
                                  <td style={{ minWidth: "90px", verticalAlign: "middle" }}>
                                    {entry.twokrun}
                                  </td> */}
                                  <td
                                    style={{
                                      minWidth: "90px",
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    {entry.total}
                                  </td>
                                </tr>
                              </>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={6}> No data found</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </section>

            <section className="standing_winner_tabs mt-4">
              <div class="custom-tabs-2 ">
                <ul class="nav nav-tabs" id="myTab_winner" role="tablist">
                  <div className="standing_tabs_btn_main_div">
                    <div className="top_perform_txt mb-2 new_all_common_heading">
                      WINNERS
                    </div>
                    <div className="standing_btns tab_btn_mobile_stand">
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link active"
                          id="Badminton_tab_winner"
                          data-bs-toggle="tab"
                          data-bs-target="#Badminton_winner"
                          onClick={() => setSelectedWinnerGame("badminton")}
                          type="button"
                          role="tab"
                          aria-controls="Badminton_winner"
                          aria-selected="true"
                        >
                          Badminton
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link"
                          id="Tennis_tab_winner"
                          data-bs-toggle="tab"
                          data-bs-target="#Tennis_winner"
                          onClick={() => setSelectedWinnerGame("table_tenis")}
                          type="button"
                          role="tab"
                          aria-controls="Tennis_winner"
                          aria-selected="false"
                        >
                          Table Tennis
                        </button>
                      </li>
                    </div>
                  </div>
                </ul>
                <div class="tab-content" id="myTabContent_winner">
                  <div
                    class="tab-pane fade show active"
                    id="Badminton_winner"
                    role="tabpanel"
                    aria-labelledby="Badminton_tab_winner"
                  >
                    {MaleWinners != null && FemaleWinners != null ? (
                      <>
                        <Row className="mt-3 justify-content-center perform_winnr_row">
                          {MaleWinners &&
                          MaleWinners.length > 0 &&
                          SelectedWinnerGame === "badminton" ? (
                            MaleWinners[0].winners &&
                            Array.isArray(MaleWinners[0].winners) &&
                            MaleWinners[0].winners.length > 0 ? (
                              MaleWinners[0].winners.map((entry, index) => (
                                <Col
                                  lg={4}
                                  md={4}
                                  xs={4}
                                  className="text-center"
                                  key={index}
                                >
                                  <div className="img_div_topperf_standing_tab">
                                    <img
                                      src={
                                        IMAGE_URL +
                                        "user/" +
                                        entry.details.profile_image
                                      }
                                      className="img_winner_tab"
                                      alt="gallery_image"
                                    />
                                    <div className="img_name_topperf_tab">
                                      {index === 0 && (
                                        <img
                                          src={gold_medal}
                                          alt="gold_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {index === 1 && (
                                        <img
                                          src={silver_medal}
                                          alt="silver_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {index === 2 && (
                                        <img
                                          src={bronze_medal}
                                          alt="bronze_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {entry.details.fname +
                                        " " +
                                        entry.details.lname}
                                    </div>
                                  </div>
                                </Col>
                              ))
                            ) : (
                              <div className="bg-dark no_txt_div_standing">
                                <p className="no_txt_standing">
                                  Tournament in progress
                                </p>
                              </div>
                            )
                          ) : (
                            <div className="bg-dark no_txt_div_standing">
                              <h4 className="no_txt_standing">No data found</h4>
                            </div>
                          )}
                        </Row>
                        {/* Female Bowling data Winner  */}
                        <Row className="mt-3 justify-content-center perform_winnr_row">
                          {FemaleWinners &&
                          FemaleWinners.length > 0 &&
                          SelectedWinnerGame === "badminton" ? (
                            FemaleWinners[0].winners &&
                            Array.isArray(FemaleWinners[0].winners) &&
                            FemaleWinners[0].winners.length > 0 ? (
                              FemaleWinners[0].winners.map((entry, index) => (
                                <Col
                                  lg={4}
                                  md={4}
                                  xs={4}
                                  className="text-center"
                                  key={index}
                                >
                                  <div className="img_div_topperf_standing_tab">
                                    <img
                                      src={
                                        IMAGE_URL +
                                        "user/" +
                                        entry.details.profile_image
                                      }
                                      className="img_winner_tab"
                                      alt="gallery_image"
                                    />
                                    <div className="img_name_topperf_tab">
                                      {index === 0 && (
                                        <img
                                          src={gold_medal}
                                          alt="gold_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {index === 1 && (
                                        <img
                                          src={silver_medal}
                                          alt="silver_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {index === 2 && (
                                        <img
                                          src={bronze_medal}
                                          alt="bronze_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {entry.details.fname +
                                        " " +
                                        entry.details.lname}
                                    </div>
                                  </div>
                                </Col>
                              ))
                            ) : (
                              <>
                                {/* <div className='bg-dark no_txt_div_standing'>
                                  <p className='no_txt_standing'>Tournament in progress</p>
                                </div> */}
                              </>
                            )
                          ) : (
                            <>
                              {/* <div className='bg-dark no_txt_div_standing'>
                                <h4 className='no_txt_standing'>Tournament in progress</h4>
                              </div> */}
                            </>
                          )}
                        </Row>
                      </>
                    ) : (
                      <div className="bg-dark no_txt_div_standing">
                        <h4 className="no_txt_standing">
                          Tournament in progress
                        </h4>
                      </div>
                    )}
                  </div>

                  <div
                    class="tab-pane fade"
                    id="2KRun_winner"
                    role="tabpanel"
                    aria-labelledby="2KRun_tab_winner"
                  >
                    {MaleWinners != null && FemaleWinners != null ? (
                      <>
                        <Row className="mt-3 justify-content-center perform_winnr_row">
                          {MaleWinners &&
                          MaleWinners.length > 0 &&
                          SelectedWinnerGame === "2k_run" ? (
                            MaleWinners[0].winners &&
                            Array.isArray(MaleWinners[0].winners) &&
                            MaleWinners[0].winners.length > 0 ? (
                              MaleWinners[0].winners.map((entry, index) => (
                                <Col
                                  lg={4}
                                  md={4}
                                  xs={4}
                                  className="text-center"
                                  key={index}
                                >
                                  <div className="img_div_topperf_standing_tab">
                                    <img
                                      src={
                                        IMAGE_URL +
                                        "user/" +
                                        entry.details.profile_image
                                      }
                                      className="img_winner_tab"
                                      alt="gallery_image"
                                    />
                                    <div className="img_name_topperf_tab">
                                      {index === 0 && (
                                        <img
                                          src={gold_medal}
                                          alt="gold_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {index === 1 && (
                                        <img
                                          src={silver_medal}
                                          alt="silver_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {index === 2 && (
                                        <img
                                          src={bronze_medal}
                                          alt="bronze_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {entry.details.fname +
                                        " " +
                                        entry.details.lname}
                                    </div>
                                  </div>
                                </Col>
                              ))
                            ) : (
                              <div className="bg-dark no_txt_div_standing">
                                <p className="no_txt_standing">
                                  Tournament in progress
                                </p>
                              </div>
                            )
                          ) : (
                            <div className="bg-dark no_txt_div_standing">
                              <h4 className="no_txt_standing">
                                Tournament in progress
                              </h4>
                            </div>
                          )}
                        </Row>
                        {/* Female 2k_Run data Winner  */}
                        <Row className="mt-3 justify-content-center perform_winnr_row">
                          {FemaleWinners &&
                          FemaleWinners.length > 0 &&
                          SelectedWinnerGame === "2k_run" ? (
                            FemaleWinners[0].winners &&
                            Array.isArray(FemaleWinners[0].winners) &&
                            FemaleWinners[0].winners.length > 0 ? (
                              FemaleWinners[0].winners.map((entry, index) => (
                                <Col
                                  lg={4}
                                  md={4}
                                  xs={4}
                                  className="text-center"
                                  key={index}
                                >
                                  <div className="img_div_topperf_standing_tab">
                                    <img
                                      src={
                                        IMAGE_URL +
                                        "user/" +
                                        entry.details.profile_image
                                      }
                                      className="img_winner_tab"
                                      alt="gallery_image"
                                    />
                                    <div className="img_name_topperf_tab">
                                      {index === 0 && (
                                        <img
                                          src={gold_medal}
                                          alt="gold_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {index === 1 && (
                                        <img
                                          src={silver_medal}
                                          alt="silver_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {index === 2 && (
                                        <img
                                          src={bronze_medal}
                                          alt="bronze_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {entry.details.fname +
                                        " " +
                                        entry.details.lname}
                                    </div>
                                  </div>
                                </Col>
                              ))
                            ) : (
                              <>
                                {/* <div className='bg-dark no_txt_div_standing'>
                                  <p className='no_txt_standing'>Tournament in progress</p>
                                </div> */}
                              </>
                            )
                          ) : (
                            <>
                              {/* <div className='bg-dark no_txt_div_standing'>
                                <h4 className='no_txt_standing'>Tournament in progress</h4>
                              </div> */}
                            </>
                          )}
                        </Row>
                      </>
                    ) : (
                      <div className="bg-dark no_txt_div_standing">
                        <h4 className="no_txt_standing">
                          Tournament in progress
                        </h4>
                      </div>
                    )}
                  </div>

                  <div
                    class="tab-pane fade"
                    id="Badminton_winner"
                    role="tabpanel"
                    aria-labelledby="Badminton_tab_winner"
                  >
                    {MaleWinners != null && FemaleWinners != null ? (
                      <>
                        <Row className="mt-3 justify-content-center perform_winnr_row">
                          {MaleWinners &&
                          MaleWinners.length > 0 &&
                          SelectedWinnerGame === "badminton" ? (
                            MaleWinners[0].winners &&
                            Array.isArray(MaleWinners[0].winners) &&
                            MaleWinners[0].winners.length > 0 ? (
                              MaleWinners[0].winners.map((entry, index) => (
                                <Col
                                  lg={4}
                                  md={4}
                                  xs={4}
                                  className="text-center"
                                  key={index}
                                >
                                  <div className="img_div_topperf_standing_tab">
                                    <img
                                      src={
                                        IMAGE_URL +
                                        "user/" +
                                        entry.details.profile_image
                                      }
                                      className="img_winner_tab"
                                      alt="gallery_image"
                                    />
                                    <div className="img_name_topperf_tab">
                                      {index === 0 && (
                                        <img
                                          src={gold_medal}
                                          alt="gold_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {index === 1 && (
                                        <img
                                          src={silver_medal}
                                          alt="silver_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {index === 2 && (
                                        <img
                                          src={bronze_medal}
                                          alt="bronze_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {entry.details.fname +
                                        " " +
                                        entry.details.lname}
                                    </div>
                                  </div>
                                </Col>
                              ))
                            ) : (
                              <div className="bg-dark no_txt_div_standing">
                                <p className="no_txt_standing">
                                  Tournament in progress
                                </p>
                              </div>
                            )
                          ) : (
                            <div className="bg-dark no_txt_div_standing">
                              <h4 className="no_txt_standing">
                                Tournament in progress
                              </h4>
                            </div>
                          )}
                        </Row>
                        {/* Female badmintion data Winner  */}
                        <Row className="mt-3 justify-content-center perform_winnr_row">
                          {FemaleWinners &&
                          FemaleWinners.length > 0 &&
                          SelectedWinnerGame === "badminton" ? (
                            FemaleWinners[0].winners &&
                            Array.isArray(FemaleWinners[0].winners) &&
                            FemaleWinners[0].winners.length > 0 ? (
                              FemaleWinners[0].winners.map((entry, index) => (
                                <Col
                                  lg={4}
                                  md={4}
                                  xs={4}
                                  className="text-center"
                                  key={index}
                                >
                                  <div className="img_div_topperf_standing_tab">
                                    <img
                                      src={
                                        IMAGE_URL +
                                        "user/" +
                                        entry.details.profile_image
                                      }
                                      className="img_winner_tab"
                                      alt="gallery_image"
                                    />
                                    <div className="img_name_topperf_tab">
                                      {index === 0 && (
                                        <img
                                          src={gold_medal}
                                          alt="gold_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {index === 1 && (
                                        <img
                                          src={silver_medal}
                                          alt="silver_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {index === 2 && (
                                        <img
                                          src={bronze_medal}
                                          alt="bronze_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {entry.details.fname +
                                        " " +
                                        entry.details.lname}
                                    </div>
                                  </div>
                                </Col>
                              ))
                            ) : (
                              <>
                                {/* <div className='bg-dark no_txt_div_standing'>
                                    <p className='no_txt_standing'>Tournament in progress</p>
                                  </div> */}
                              </>
                            )
                          ) : (
                            <>
                              {/* <div className='bg-dark no_txt_div_standing'>
                                  <h4 className='no_txt_standing'>Tournament in progress</h4>
                                </div> */}
                            </>
                          )}
                        </Row>
                      </>
                    ) : (
                      <div className="bg-dark no_txt_div_standing">
                        <h4 className="no_txt_standing">
                          Tournament in progress
                        </h4>
                      </div>
                    )}
                  </div>

                  <div
                    class="tab-pane fade"
                    id="Tennis_winner"
                    role="tabpanel"
                    aria-labelledby="Tennis_tab_winner"
                  >
                    {MaleWinners != null && FemaleWinners != null ? (
                      <>
                        <Row className="mt-3 justify-content-center perform_winnr_row">
                          {MaleWinners &&
                          MaleWinners.length > 0 &&
                          SelectedWinnerGame === "table_tenis" ? (
                            MaleWinners[0].winners &&
                            Array.isArray(MaleWinners[0].winners) &&
                            MaleWinners[0].winners.length > 0 ? (
                              MaleWinners[0].winners.map((entry, index) => (
                                <Col
                                  lg={4}
                                  md={4}
                                  xs={4}
                                  className="text-center"
                                  key={index}
                                >
                                  <div className="img_div_topperf_standing_tab">
                                    <img
                                      src={
                                        IMAGE_URL +
                                        "user/" +
                                        entry.details.profile_image
                                      }
                                      className="img_winner_tab"
                                      alt="gallery_image"
                                    />
                                    <div className="img_name_topperf_tab">
                                      {index === 0 && (
                                        <img
                                          src={gold_medal}
                                          alt="gold_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {index === 1 && (
                                        <img
                                          src={silver_medal}
                                          alt="silver_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {index === 2 && (
                                        <img
                                          src={bronze_medal}
                                          alt="bronze_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {entry.details.fname +
                                        " " +
                                        entry.details.lname}
                                    </div>
                                  </div>
                                </Col>
                              ))
                            ) : (
                              <div className="bg-dark no_txt_div_standing">
                                <p className="no_txt_standing">
                                  Tournament in progress
                                </p>
                              </div>
                            )
                          ) : (
                            <div className="bg-dark no_txt_div_standing">
                              <h4 className="no_txt_standing">No data found</h4>
                            </div>
                          )}
                        </Row>

                        {/* Female Table_tennis data Winner  */}
                        <Row className="mt-3 justify-content-center perform_winnr_row">
                          {FemaleWinners &&
                          FemaleWinners.length > 0 &&
                          SelectedWinnerGame === "table_tenis" ? (
                            FemaleWinners[0].winners &&
                            Array.isArray(FemaleWinners[0].winners) &&
                            FemaleWinners[0].winners.length > 0 ? (
                              FemaleWinners[0].winners.map((entry, index) => (
                                <Col
                                  lg={4}
                                  md={4}
                                  xs={4}
                                  className="text-center"
                                  key={index}
                                >
                                  <div className="img_div_topperf_standing_tab">
                                    <img
                                      src={
                                        IMAGE_URL +
                                        "user/" +
                                        entry.details.profile_image
                                      }
                                      className="img_winner_tab"
                                      alt="gallery_image"
                                    />
                                    <div className="img_name_topperf_tab">
                                      {index === 0 && (
                                        <img
                                          src={gold_medal}
                                          alt="gold_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {index === 1 && (
                                        <img
                                          src={silver_medal}
                                          alt="silver_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {index === 2 && (
                                        <img
                                          src={bronze_medal}
                                          alt="bronze_medal"
                                          className="me-1 medal_img_standing"
                                        />
                                      )}
                                      {entry.details.fname +
                                        " " +
                                        entry.details.lname}
                                    </div>
                                  </div>
                                </Col>
                              ))
                            ) : (
                              <>
                                {/* <div className='bg-dark no_txt_div_standing'>
                                    <p className='no_txt_standing'>Tournament in progress</p>
                                  </div> */}
                              </>
                            )
                          ) : (
                            <>
                              {/* <div className='bg-dark no_txt_div_standing'>
                                <h4 className='no_txt_standing'>Tournament in progress</h4>
                              </div> */}
                            </>
                          )}
                        </Row>
                      </>
                    ) : (
                      <div className="bg-dark no_txt_div_standing">
                        <h4 className="no_txt_standing">
                          Tournament in progress
                        </h4>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Standing;
